import {Component, ElementRef, EventEmitter, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-confirmation-toggle',
    templateUrl: './confirmation-toggle.component.html',
    styleUrls: ['./confirmation-toggle.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationToggleComponent {
  @Output() confirmed = new EventEmitter();

  @ViewChild('modal', { static: true }) modal: ElementRef;

  toggleModal() {
    $(this.modal.nativeElement).modal("show");
  }
}
